<template>
	<BasePlaceHolder :placehold="!annualReturns">
		<table class="fundrise-comparison-table table text-color-content-primary my-200 epsilon">
			<colgroup>
				<col class="table-column--years" />
				<col class="table-column--fundrise" />
				<col class="table-column--reits" />
				<col class="table-column--stocks" />
			</colgroup>
			<thead>
				<tr>
					<th> <span class="show-for-sr">Year</span> </th>
					<th class="fundrise-returns-column">
						<span class="logo-wrap px-100">
							<BaseSvgIcon
								name="fundrise-logo-wordmark"
								:width="logoWidth"
								:height="logoHeight"
								class="mr-25"
							/><sup v-if="hasDisclaimers" class="logo-superscript">1</sup>
						</span>
					</th>
					<th> Public REITs<sup v-if="hasDisclaimers">2</sup> </th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(assetClass, k) in tableData" :key="k">
					<th>{{ assetClass.year }}</th>
					<td :class="['fundrise-returns-td', returnsColorClass(assetClass.fundrise)]">{{
						percentage(assetClass.fundrise, true, 2)
					}}</td>
					<td :class="returnsColorClass(assetClass.reits)">{{ percentage(assetClass.reits, true, 2) }}</td>
				</tr>
			</tbody>
		</table>
	</BasePlaceHolder>
</template>

<script setup lang="ts">
import { AnnualReturnsRow, SanityAnnualReturnsTable } from 'types/annual-returns';
import { computed, ref, Ref } from 'vue';
import { getAnnualReturnsTableData } from '@api/sanity/graphql/charts-data';
import { percentage } from '@filters/shared-filters';
import { useAppStore } from '@stores/app';

interface Props {
	hasDisclaimers?: boolean;
	limitScopeTo?: number;
}

const props = withDefaults(defineProps<Props>(), {
	hasDisclaimers: true,
	limitScopeTo: undefined
});

const appStore = useAppStore();

const annualReturns: Ref<SanityAnnualReturnsTable | null> = ref(null);

function returnsColorClass(value: string): string {
	return !!value && String(value).includes('-') ? 'text-color-red' : 'text-color-green';
}

const dataScope = computed((): number => {
	const tableLength = annualReturns.value?.tableData?.length || 0;

	return props.limitScopeTo && props.limitScopeTo < tableLength ? props.limitScopeTo : tableLength;
});

const logoHeight = computed((): string => (appStore.isMobile ? '30' : '42'));

const logoWidth = computed((): string => (appStore.isMobile ? '52' : '75'));

const tableData = computed((): Array<AnnualReturnsRow> => {
	return annualReturns.value?.tableData.slice(0, dataScope.value) ?? [];
});

async function setup(): Promise<void> {
	try {
		annualReturns.value = await getAnnualReturnsTableData('annual-returns-table-snapshot-view');
	} catch {}
}
setup();
</script>
